export const GET_DINING_OPTIONS = 'providers/settings/DiningOptions/GET_DINING_OPTIONS';
export const GET_DINING_OPTION_DETAIL = 'providers/settings/DiningOptions/GET_DINING_OPTION_DETAIL';
export const CREATE_DINING_OPTION = 'providers/settings/DiningOptions/CREATE_DINING_OPTION';
export const DELETE_DINING_OPTION = 'providers/settings/DiningOptions/DELETE_DINING_OPTION';
export const EDIT_DINING_OPTION = 'providers/settings/DiningOptions/EDIT_DINING_OPTION';
export const SET_IS_ENABLED_DINING_OPTION = 'providers/settings/DiningOptions/SET_IS_ENABLED_DINING_OPTION';
export const SET_IS_DEFAULT_DINING_OPTION = 'providers/settings/DiningOptions/SET_IS_DEFAULT_DINING_OPTION';
